import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@chain-zen/ui'

import { WORKSPACE_ROUTES } from '../../constants/routes'
import type { IPublicPostData } from '../../types/post'
import { CommodityStopCountWeightColumn } from '../shared/commodity-stop-weight-column'
import { OriginOrDestination } from '../shared/origin-destination'

interface ITableViewProps {
  postsData: IPublicPostData[]
  workspacename: string
  enterpriseWorkspaceID: string | null | undefined
}

const TableView = ({ postsData, workspacename, enterpriseWorkspaceID }: ITableViewProps) => {
  const handleRowClick = (row: IPublicPostData) => {
    if (enterpriseWorkspaceID) {
      if (row.workspace.workspacename) {
        window.open(`${window.location.origin}/${WORKSPACE_ROUTES.PUBLIC_POSTS(row.workspace.workspacename)}/${row.id}`)
      }
    } else {
      window.open(`${window.location.origin}/${WORKSPACE_ROUTES.PUBLIC_POSTS(workspacename)}/${row.id}`)
    }
  }
  return (
    <div className="w-full overflow-auto">
      {postsData.length > 0 && (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Pickup</TableHead>
              <TableHead>Delivery</TableHead>
              <TableHead>Details</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {postsData.map((row) => (
              <TableRow key={row.id} className="cursor-pointer" onClick={() => handleRowClick(row)}>
                <TableCell>
                  <OriginOrDestination
                    appointment={row.originAppointment}
                    city={row.origin?.city || null}
                    fontSize="xs"
                    state={row.origin?.stateCode || null}
                    type="Pick"
                  />
                </TableCell>
                <TableCell>
                  <OriginOrDestination
                    appointment={row.destinationAppointment}
                    city={row.destination?.city || null}
                    fontSize="sm"
                    state={row.destination?.stateCode || null}
                    type="Drop"
                  />
                </TableCell>
                <TableCell>
                  <CommodityStopCountWeightColumn
                    weight={row.weight}
                    truckTypes={row.truckType}
                    picksCount={row.numberOfPicks || null}
                    dropsCount={row.numberOfDrops || null}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  )
}

export default TableView
